import React, { ReactElement } from 'react'
import styled from '@emotion/styled'

import { Bilabel, BilabelProps } from './Bilabel'
import { breakpoints } from '../styles/variables'
import { useIsTablet } from '../hooks/useIsTablet'

const StyledProductBlock = styled.div`
  display: grid;
  grid-template-columns: 2rem 4rem auto 2rem;
  grid-template-rows: auto auto;

  @media (min-width: ${breakpoints.tablet}px) {
    background: var(--color-figure-0025);
    grid-template-columns: 50% 3rem auto 3rem;
    grid-template-rows: 1fr auto 2rem auto 2rem;
  }
`

const Image = styled.div`
  grid-column: 1 / 5;
  grid-row: 1;

  @media (min-width: ${breakpoints.tablet}px) {
    grid-column: 1;
    grid-row: 1 / -1;
  }
`

const LabelWrapper = styled.div`
  align-self: start;
  font-size: var(--font-size-l2);
  grid-column: 2;
  grid-row: 2;
  height: 0;
  justify-self: start;

  @media (min-width: ${breakpoints.tablet}px) {
    grid-column: 3;
    grid-row: 2;
    height: auto;
  }
`

const Label = styled(Bilabel)`
  transform: translateY(-50%);

  @media (min-width: ${breakpoints.tablet}px) {
    transform: none;
  }
`

const Content = styled.div`
  font-feature-settings: 'palt';
  font-size: var(--font-size-s1);
  grid-column: 3;
  grid-row: 2;
  line-height: 2;

  p {
    margin: 2em 0;
  }

  @media (min-width: ${breakpoints.tablet}px) {
    grid-column: 3;
    grid-row: 4;
  }
`

type ProductBlockProps = BilabelProps & {
  image: ReactElement
}

export const ProductBlock: React.FC<ProductBlockProps> = ({
  image,
  sublabel,
  label,
  children,
}) => {
  const isTablet = useIsTablet()

  return (
    <StyledProductBlock>
      <Image>{image}</Image>
      <LabelWrapper>
        <Label
          sublabel={sublabel}
          label={label}
          mode={isTablet ? 'normal' : 'vertical'}
        />
      </LabelWrapper>
      <Content>{children}</Content>
    </StyledProductBlock>
  )
}
